import { useState, useEffect } from "react";

import { loadDepartment } from "../services/departmentService";

const useDepartment = (editID) => {

    const [department, setDepartment] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [selectedDepartmentID, setSelectedDepartmentID] = useState(null);
    const [isDepartmentDataLoaded, setIsDepartmentDataLoaded] = useState(false);

    // Fetch department data
    const fetchDepartmentList = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadDepartment(para);
            if (data && data.length > 0) {
                setDepartment(data);
                const initialDepartment = data.find((dept) => dept.id === selectedID);

                if (initialDepartment) { // ✅ Corrected check
                    setSelectedDepartment(initialDepartment);
                    setSelectedDepartmentID(initialDepartment.id);
                    setIsDepartmentDataLoaded(true);
                }

            }
            else{
                 setDepartment([]);
               
                    setSelectedDepartment(null);
                    setSelectedDepartmentID(null);
                    setIsDepartmentDataLoaded(false);
                

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isDepartmentDataLoaded && editID === 0) {
            fetchDepartmentList();
        }
    }, [isDepartmentDataLoaded, editID]);

    // Function to load department based on selected ID
    const loadDepartmentByID = async (selectedID) => {
        await fetchDepartmentList(selectedID);
    };

    return {
        department,
        selectedDepartment,
        selectedDepartmentID,
        setSelectedDepartment,
        setSelectedDepartmentID,
        loadDepartmentByID,
    };
};

export default useDepartment;
